import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Tidy First? by Kent Beck"
        desc="A personal exercise in empirical software design"
        keyword="tidy first, software design, kent beck, refactoring, tidyings"
        image="/images/books/tidy-first.jpg"
        pageType="book"
        author="Kent Beck"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/tidy-first.jpg"
                alt="tidy first kent beck engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Tidy First?
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Kent Beck</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Kent Beck, the creator of Extreme Programming and a pioneer of software patterns,
                explores the art of making small, structural changes to code before changing its
                behavior. Tidy First? is the first in a series on empirical software design, and it
                asks a deceptively simple question: should you clean up the code before making your
                next change?
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                The book introduces "tidyings" — small, safe, reversible code improvements like
                extracting helpers, reordering statements, or removing dead code. These tidyings are
                not refactorings in the traditional sense; they are quick, low-risk moves that make
                the next behavioral change easier and safer.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Beyond the practical techniques, Kent Beck connects software design to economics and
                optionality, showing how the decision of when to tidy is ultimately about managing
                the cost of change over time. A must-read for anyone who wants to write code that is
                easier to understand, change, and extend.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
